<template>
  <div class="workbooks" role="alert">
    <div class="workbooks__wrapper">
      <button @click="$emit('toggle-workbooks')" class="workbooks__close-btn">
        <CloseIcon class="workbooks__close-btn--icon" />
      </button>
      <div class="workbooks__categories-wrapper">
        <div class="workbooks__categories">
          <button
            v-for="category in categories"
            :key="`category-${category.title}`"
            @click="updateSelectedCategory(category)"
            :class="[
              'workbooks__category',
              category === selectedCategory && 'workbooks__category--selected',
            ]"
          >
            {{ category.title }}
          </button>
        </div>
        <div class="workbooks__links">
          <a
            v-for="workbook in selectedCategory.workbooks"
            :key="`workbook-${workbook.title}`"
            :href="workbook.link"
            class="workbooks__link"
            >{{ workbook.title }}</a
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CloseIcon from '@/assets/icons/navigation/close_icon.svg'
import workbooks from '@/static/workbooks'

export default {
  name: 'Workbooks',
  components: {
    CloseIcon: { ...CloseIcon, name: 'CloseIcon' },
  },
  data() {
    return {
      categories: workbooks,
      selectedCategory: workbooks[0],
    }
  },
  methods: {
    updateSelectedCategory(category) {
      this.selectedCategory = category
    },
  },
}
</script>

<style lang="scss" scoped>
.workbooks {
  $this: &;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99999;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  &__wrapper {
    height: 95vh;
    width: 95vw;
    background: var(--dark-gray);
    border: 1px solid var(--gray);
    position: relative;
    padding: 25px;
    @include tablet {
      height: 75vh;
      width: 75vw;
    }
  }
  &__close-btn {
    width: 50px;
    height: 50px;
    position: absolute;
    right: 0;
    top: 0;
    background: none;
    border: none;
    cursor: pointer;
    &:hover {
      .workbooks__close-btn--icon {
        fill: var(--orange);
      }
    }
    &--icon {
      fill: var(--white);
    }
  }
  &__categories-wrapper {
    display: block;
    @include tablet {
      display: flex;
    }
  }
  &__categories {
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    @include tablet {
      display: flex;
      flex-direction: column;
      align-items: stretch;
      width: 30%;
    }
  }
  &__category {
    margin: 5px 0;
    background-color: var(--light-gray);
    border: 1px solid var(--dark-gray);
    padding: 5px;
    font-size: 1.2rem;
    font-family: var(--font-bold);
    color: var(--white);
    cursor: pointer;
    @include tablet {
      padding: 15px 25px;
    }
    &:hover {
      opacity: 0.8;
    }
    &--selected {
      background-color: var(--orange);
    }
  }
  &__links {
    display: flex;
    flex-direction: column;
    width: 100%;
    @include tablet {
      width: 70%;
      padding: 0 25px;
    }
  }
  &__link {
    font-size: 1rem;
    background-color: var(--light-gray);
    border-radius: 2px;
    color: var(--white);
    text-decoration: none;
    margin: 5px 0;
    width: 100%;
    padding: 5px;
    cursor: pointer;
    @include tablet {
      padding: 5px 25px;
    }
    &:hover {
      opacity: 0.8;
      background-color: var(--white);
      color: var(--black);
    }
  }
}
</style>
